import { addNotification, removeNotification } from './slices/notificationsSlice';

export const addNotificationWithTimeout = (dispatch, type, text) => {    
    const key = Math.floor(Math.random() * 1000000).toString();

    dispatch(addNotification({
        "key": key,
        "type": type,
        "text": text
    }));

    setTimeout(() => {
        dispatch(removeNotification(key));
    }, 3000);
}